module.exports = __webpack_public_path__ + "img/icon_drop_right.79d4322d.svg";